import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_PROFILE = `${ENDPOINT_BASE}/profile`
